/**
 * Delete Blog Post API
 *
 * Delete blog posts from Supabase.
 * @see src/features/blog/hooks/useDeleteBlogPost.ts for React Query wrapper
 */

import { supabase } from '@/lib/supabase';

/**
 * Delete a blog post
 * This is a hard delete - the post will be permanently removed
 * @param id - The blog post ID to delete
 * @returns Promise that resolves when deletion is complete
 */
export const deleteBlogPost = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from('blog_posts')
    .delete()
    .eq('id', id);

  if (error) throw error;
};
